export const pubSubEvents = {
    apiRequestWasMade: 'apiRequestWasMade',
    logoutInitiated: 'logoutInitiated',
    nextAllowedBidCopied: 'nextAllowedBidCopied',
    userSessionExpired: 'userSessionExpired',
};
